import { render, staticRenderFns } from "./OrdersTab.vue?vue&type=template&id=db5eed8a"
import script from "./OrdersTab.vue?vue&type=script&lang=js"
export * from "./OrdersTab.vue?vue&type=script&lang=js"
import style0 from "./OrdersTab.vue?vue&type=style&index=0&id=db5eed8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports